import { render, staticRenderFns } from "./roomRateList.vue?vue&type=template&id=4df6bda4"
import script from "./roomRateList.vue?vue&type=script&lang=js"
export * from "./roomRateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports